/**
 * only add exceptions which can not automatically convert. like _cd fields
 */

const toJsonMapping = {
  contactPersonGender: 'contact_person_gender_cd',
  correspondenceLanguage: 'correspondence_language_cd',
  correspondenceRecipientPerson: {
    gender: 'gender_cd',
  },
  differentOwnerPersonGender: 'different_owner_person_gender_cd',
  persons: {
    gender: 'gender_cd',
    correspondenceLanguage: 'correspondence_language_cd',
  },
  signingMode: 'signing_mode_cd',
  authorizedSignatories: {
    gender: 'gender_cd',
  },
}

export default toJsonMapping
